import { z } from "zod";
import { nullishToOptional } from "../../../helpers/nullish-to-optional";

//
// Enums
//

export const FigmaNodeRenderState = z.enum(["InProgress", "Success", "Failed"]);
export const FigmaNodeRenderFormat = z.enum(["Png", "Svg"]);
export const FigmaNodeRenderErrorType = z.enum(["MissingIntegration", "NodeNotFound", "RenderError"]);

export type FigmaNodeRenderState = z.infer<typeof FigmaNodeRenderState>;
export type FigmaNodeRenderFormat = z.infer<typeof FigmaNodeRenderFormat>;
export type FigmaNodeRenderErrorType = z.infer<typeof FigmaNodeRenderErrorType>;

//
// Definition
//

export const FigmaNodeRelinkData = z.object({
  fileId: z.string(),
});

export const FigmaNodeRenderedImage = z.object({
  resourceId: z.string(),
  format: FigmaNodeRenderFormat,
  scale: nullishToOptional(z.number()),

  width: nullishToOptional(z.number()),
  height: nullishToOptional(z.number()),
  url: nullishToOptional(z.string()),
  originKey: nullishToOptional(z.string()),
});

export const FigmaNodeRenderError = z.object({
  type: FigmaNodeRenderErrorType,
});

export const FigmaNodeReferenceData = z.object({
  sceneNodeId: z.string(),
  format: FigmaNodeRenderFormat,
  scale: nullishToOptional(z.number()),

  renderState: FigmaNodeRenderState,
  renderedImage: FigmaNodeRenderedImage.optional(),
  renderError: FigmaNodeRenderError.optional(),

  hasSource: z.boolean(),
  relinkData: FigmaNodeRelinkData.optional(),
});

export type FigmaNodeRelinkData = z.infer<typeof FigmaNodeRelinkData>;
export type FigmaNodeRenderedImage = z.infer<typeof FigmaNodeRenderedImage>;
export type FigmaNodeRenderError = z.infer<typeof FigmaNodeRenderError>;
export type FigmaNodeReferenceData = z.infer<typeof FigmaNodeReferenceData>;
